/* src/app/component/header/countdown/countdown.component.scss */
.game__countdown {
  display: flex;
  width: fit-content;
  margin: 0;
  background: #ffffff;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
}
@media screen and (min-width: 48rem) {
  .game__countdown {
    margin: 0 0 0 1rem;
    padding: 0.25rem 2rem;
  }
}
.game__countdown h3 {
  color: #262626;
  font-size: 1.25rem;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  margin-bottom: 0;
}
@media screen and (min-width: 48rem) {
  .game__countdown h3 {
    font-size: 1.5rem;
  }
}
/*# sourceMappingURL=countdown.component.css.map */
